'use-client';
import * as React from 'react';
import {
  getAccessibilityAttributes,
  getDataAttributes,
} from '@wix/editor-elements-common-utils';
import type { IDocumentMediaProps } from '../DocumentMedia.types';
import Image from '../../Image/viewer/Image';
import Link from '../../Link/viewer/Link';
import styles from './styles/DocumentMedia.scss';

const DocumentMedia: React.FC<IDocumentMediaProps> = props => {
  const {
    id,
    title,
    image,
    link,
    className,
    reportBiOnClick,
    onMouseEnter,
    onMouseLeave,
    ariaAttributes,
    a11y,
    translations,
  } = props;

  const { ariaAttributes: a11yProps } = React.useMemo(
    () =>
      getAccessibilityAttributes({
        ariaAttributes: {
          ...a11y,
          ...ariaAttributes,
          label:
            ariaAttributes?.label ||
            a11y?.label ||
            title ||
            link?.docInfo?.name ||
            translations.ariaLabel,
        },
      }),
    [a11y, ariaAttributes, title, link, translations],
  );

  return (
    <div
      id={id}
      {...getDataAttributes(props)}
      onClick={reportBiOnClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={className}
    >
      <Link
        {...link}
        className={styles.link}
        title={title || image.alt}
        {...a11yProps}
      >
        <div className={styles.imageContainer} aria-hidden="true">
          <Image
            {...image}
            id={`image-${id}`}
            className={styles.image}
            containerId={id}
            displayMode="fit"
            name=""
          />
        </div>
        {title && <span className={styles.title}>{title}</span>}
      </Link>
    </div>
  );
};

export default DocumentMedia;
